import { useEffect } from 'react';
import {
    Box, Grid, TextField, FormControl, FormLabel, Typography,
    RadioGroup, FormControlLabel, Radio, Checkbox, Button
} from '@mui/material';

const RequestsTools = ({
    startDate, setStartDate,
    endDate, setEndDate,
    mode, setMode,
    email, setEmail,
    showTotalRequests, setShowTotalRequests,
    showUniqueUsers, setShowUniqueUsers,
    fetchStats, setSelectedChart
}) => {

    // סימון אוטומטי של "כמות קריאות" במצב "משתמש ספציפי"
    useEffect(() => {
            if (mode === 'user') {
                setShowTotalRequests(true);
            }
        }, [mode, setShowTotalRequests]);

    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={1} alignItems="center" flexWrap="wrap" direction="row">
                <Typography variant="h6" sx={{ mr: 1, mt: 1 }}>
                    קריאות למערכת
                </Typography>

                {/* תאריך התחלה */}
                <Grid item>
                    <TextField
                        label="מתאריך"
                        type="date"
                        size="small"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                {/* תאריך סיום */}
                <Grid item>
                    <TextField
                        label="עד תאריך"
                        type="date"
                        size="small"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mr: 2 }}
                    />
                </Grid>

                {/* תצוגה */}
                <Grid item>
                    <FormControl component="fieldset" size="small">
                        <FormLabel
                            component="legend"
                            sx={{ fontSize: '0.8rem', mb: 0.2 }}
                        >
                            תצוגה
                        </FormLabel>
                        <RadioGroup
                            value={mode}
                            onChange={(e) => setMode(e.target.value)}
                            sx={{ flexDirection: 'column', gap: 0 }}
                        >
                            <FormControlLabel
                                value="all"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            p: 0.5,
                                            '& .MuiSvgIcon-root': { fontSize: 16 }
                                        }}
                                    />
                                }
                                label="כולם"
                                sx={{ mb: 0 }}
                            />
                            <FormControlLabel
                                value="user"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            p: 0.5,
                                            '& .MuiSvgIcon-root': { fontSize: 16 }
                                        }}
                                    />
                                }
                                label="משתמש ספציפי"
                                sx={{ mb: 0 }}
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                {/* גרפים / אימייל */}
                <Grid item sx={{ width: 215 }}>
                    {mode === 'all' ? (
                        <FormControl component="fieldset" size="small">
                            <FormLabel
                                component="legend"
                                sx={{ fontSize: '0.8rem', mb: 0.2 }}
                            >
                                גרפים
                            </FormLabel>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={showTotalRequests}
                                            onChange={(e) => setShowTotalRequests(e.target.checked)}
                                            sx={{
                                                p: 0.5,
                                                '& .MuiSvgIcon-root': { fontSize: 16 }
                                            }}
                                        />
                                    }
                                    label="כמות קריאות"
                                    sx={{ mb: 0 }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={showUniqueUsers}
                                            onChange={(e) => setShowUniqueUsers(e.target.checked)}
                                            sx={{
                                                p: 0.5,
                                                '& .MuiSvgIcon-root': { fontSize: 16 }
                                            }}
                                        />
                                    }
                                    label="משתמשים שונים"
                                    sx={{ mb: 0 }}
                                />
                            </Box>
                        </FormControl>
                    ) : (
                        // אימייל משתמש
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '200px' }}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setSelectedChart('activeUsers')}
                                sx={{ height: '30px' }}
                                fullWidth
                            >
                                בחר משתמש
                            </Button>
                            <TextField
                                label="או הכנס אימייל"
                                size="small"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{ height: '30px' }}
                                inputProps={{ dir: 'ltr' }}
                                fullWidth
                                InputProps={{
                                    sx: { height: 30 }
                                }}
                            />
                        </Box>
                    )}
                </Grid>

                {/* כפתור טעינה */}
                <Grid item>
                    <Button variant="contained" size="small" onClick={fetchStats}>
                        טען
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default RequestsTools;
